export const NO_CONTENT_MESSAGE =
  "No content available yet. Please transcribe or upload your assessment.";

export const FETCHING_MESSAGE = "Fetching assessment data.";

// Whole-section "nothing found" replies from the transcription service (MDRS-576).
// Mirrored in backend/utils/assessment.py (EMPTY_SECTION_SENTENCES).
export const EMPTY_SECTION_SENTENCES = [
  "No relevant information was identified in the supplied material for this section.",
  "No such information available from the transcript.",
];
